exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-container[data-v-eeb35724] {\n  padding: 0 10px;\n}", ""]);

// exports
